import type { CandidateDto } from '../candidate.dto';

export type Education = {
  field: string | undefined;
  degree: string;
  schoolName: string | undefined;
  startDate: { month: number | undefined; year: number | undefined };
  endDate: { month: number | undefined; year: number | undefined };
  startEpochTimeInMonths: number;
  endEpochTimeInMonths: number | undefined;
  description: string | undefined;
};

export const toEducations = (candidate: CandidateDto): Education[] => {
  return candidate._source.experiences.educations.map<Education>((education) => ({
    field: education.field,
    degree: education.degree,
    schoolName: education.school?.name || undefined,
    startDate: {
      month: education.dates.start?.month,
      year: education.dates.start?.year,
    },
    endDate: {
      month: education.dates.end?.month,
      year: education.dates.end?.year,
    },
    startEpochTimeInMonths: education.dates.start_recalculated,
    endEpochTimeInMonths: education.dates.end_recalculated,
    description: education.description,
  }));
};
